import PageAction from './PageAction';
import LoadAction from './LoadAction';

export {PageAction, LoadAction};



// WEBPACK FOOTER //
// ./src/actions/index.js